import cx from 'classnames';
import { createUseHtmlId } from '../../../hooks/useHtmlId';
import { useTruncationTooltip } from '../../../hooks/useTruncationTooltip';
import { Divider } from '../../Divider';
import cn from './MenuListSection.css.json';
import './MenuListSection.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTitleId = createUseHtmlId('Menu-group');

/**
 * @internal
 */
export const MenuListSection = props => {
  const titleId = useTitleId();
  const truncationTitleRef = useTruncationTooltip();
  const isFirst = props.index === 0;
  const hasTitle = !!props.section.title;
  const titleCls = cx(cn.title, props.disabled && cn.titleDisabled);
  const divider = /*#__PURE__*/_jsx("div", {
    className: cn.divider,
    onMouseEnter: props.onSubmenuClosed,
    children: /*#__PURE__*/_jsx(Divider, {})
  });
  return /*#__PURE__*/_jsxs("div", {
    role: "group",
    "aria-label": !hasTitle ? props.section.ariaLabel || `${props.index + 1}` : undefined,
    "aria-labelledby": hasTitle ? titleId : undefined,
    "aria-disabled": props.disabled ? 'true' : undefined,
    children: [!isFirst && divider, hasTitle ? /*#__PURE__*/_jsx("div", {
      ref: truncationTitleRef,
      id: titleId,
      className: titleCls,
      onMouseEnter: props.onSubmenuClosed,
      children: props.section.title
    }) : null, props.children]
  }, props.index);
};
//# sourceMappingURL=MenuListSection.js.map